import Image from "next/image";
import StrapiBlocksRenderer from "~/components/reusables/strapi-blocks-renderer";
import { cn } from "~/lib/utils";
import { Button } from "components/ui/button";
import { ArrowLongRight } from "~/components/icons";
import { Separator } from "components/ui/separator";
import EventCardDetail from "./event-card-detail";
import { LinkTrackers } from "~/components/reusables/link-trackers";

const EventCard = ({ event, forceHeight = "null", passedEvent = false }) => {
  const { id } = event;
  const eventImage = event?.picture;
  const ctaBtn = event?.ctaBtn[0];

  return (
    <>
      {passedEvent && !ctaBtn?.url?.includes(".on24") ? (
        <div className="group flex flex-col justify-between gap-5" key={id}>
          <div>
            <div
              className={cn(
                `relative mx-auto aspect-[960/502] overflow-hidden rounded-xl md:min-h-[180px]`,
                forceHeight,
              )}
            >
              <Image
                unoptimized
                src={eventImage?.url}
                fill
                alt="Featured home blog"
                className="h-full w-auto rounded-xl object-cover transition-all duration-700 group-hover:scale-105"
                sizes="100%"
              />
            </div>
            <div className="flex flex-col gap-2 px-6 py-5 md:gap-4">
              {event?.type && (
                <div className="flex">
                  <h6
                    className={`font-p-sm rounded-full text-[10px] uppercase text-black ${
                      event?.type == "In-Person"
                        ? "bg-[#92CD77]"
                        : event?.type == "Partner Events"
                          ? "bg-[#F2EE4A]"
                          : "bg-[#0BBDE0]"
                    } px-4 pb-1 pt-2`}
                  >
                    {event?.type}
                  </h6>
                </div>
              )}
              <h3 className={"font-h4"}>{event?.title}</h3>
              {event?.blurb && (
                <div className="">
                  <StrapiBlocksRenderer content={event?.blurb} sm />
                </div>
              )}
            </div>
          </div>
          <div className="flex flex-col gap-2 px-6 py-5 md:gap-4">
            {[
              { timeFrame: event.timeFrame },
              { eventTime: event.eventTime },
              { location: event.location },
            ]
              .filter((item) => Object.values(item)[0] != null)
              .map((item, idx, arr) => (
                <div key={idx}>
                  <EventCardDetail item={item} />
                  {idx < arr.length - 1 && <Separator className="mt-3" />}
                </div>
              ))}
          </div>
        </div>
      ) : (
        <LinkTrackers
          segmentMsg="Register now clicked"
          segmentOpt={{
            link_label: passedEvent ? "Watch on Demand" : ctaBtn?.cta,
            location: "body",
            event_type: event?.type,
            event_title: event?.title,
            resource_interaction: "visit event registration page",
          }}
          href={ctaBtn?.url || "/"}
          className="group flex flex-col justify-between gap-5"
          target={ctaBtn?.external ? "_blank" : "_self"}
          key={id}
        >
          <div>
            <div
              className={cn(
                `relative mx-auto aspect-[960/502] overflow-hidden rounded-xl md:min-h-[180px]`,
                forceHeight,
              )}
            >
              <Image
                unoptimized
                src={eventImage?.url}
                fill
                alt="Featured home blog"
                className="h-full w-auto rounded-xl object-cover transition-all duration-700 group-hover:scale-105"
                sizes="100%"
              />
            </div>
            <div className="flex flex-col gap-2 px-6 py-5 md:gap-4">
              {event?.type && (
                <div className="flex">
                  <h6
                    className={`font-p-sm rounded-full text-[10px] uppercase text-black ${
                      event?.type == "In-Person"
                        ? "bg-[#92CD77]"
                        : event?.type == "Partner Events"
                          ? "bg-[#F2EE4A]"
                          : "bg-[#0BBDE0]"
                    } px-4 pb-1 pt-2`}
                  >
                    {event?.type}
                  </h6>
                </div>
              )}
              <h3 className={"font-h4"}>{event?.title}</h3>
              {event?.blurb && (
                <div className="">
                  <StrapiBlocksRenderer content={event?.blurb} sm />
                </div>
              )}
            </div>
          </div>
          <div className="flex flex-col gap-2 px-6 py-5 md:gap-4">
            {[
              { timeFrame: event.timeFrame },
              { eventTime: event.eventTime },
              { location: event.location },
            ]
              .filter((item) => Object.values(item)[0] != null)
              .map((item, idx, arr) => (
                <div key={idx}>
                  <EventCardDetail item={item} />
                  {idx < arr.length - 1 && <Separator className="mt-3" />}
                </div>
              ))}
            <Button
              className="rounded-lg group-hover:bg-slate-900/90"
              size={"lg"}
            >
              <p className="font-p">
                {passedEvent ? "Watch on Demand" : ctaBtn?.cta}
              </p>
              <ArrowLongRight size={30} />
            </Button>
          </div>
        </LinkTrackers>
      )}
    </>
  );
};

export default EventCard;
